/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const DownloadColumnFormatter = ( cellContent, row, rowIndex, {downloadFile}) => (
  <>
    {/* <a
      href={`${toAbsoluteUrl("https://cc-demo-dashboard.herokuapp.com/uploads/banners/")}${row.banner_file}`}
      title={row.banner_file}
      className="btn btn-light-info btn-sm"
    >
      <i className="fas fa-cloud-download-alt"></i> Download
    </a> */}

    <button className="btn btn-light-info btn-sm" title={row.banner_file} onClick={() => downloadFile(row.banner_file,row.banner_file)}> 
      <i className="fas fa-cloud-download-alt"></i> Download 
    </button>
  </>
);
